import { render, staticRenderFns } from "./NewEvaluation.vue?vue&type=template&id=24de5fb6&scoped=true"
import script from "./NewEvaluation.vue?vue&type=script&lang=js"
export * from "./NewEvaluation.vue?vue&type=script&lang=js"
import style0 from "./NewEvaluation.vue?vue&type=style&index=0&id=24de5fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24de5fb6",
  null
  
)

export default component.exports